import { OnboardingGuideInterfaceNeverShowAgain } from "../../src/components/onboarding-guide/onboarding-guide-interface";
import fs from "fs";
const output = `${__dirname}/../../resources/generated-mock-data/`;

const response: OnboardingGuideInterfaceNeverShowAgain = { success: true };

const writeToFile = (object: any, name: string): void => {
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object, null, 2));
};

writeToFile(response, "onboarding-guide-never-show-again");
